"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("jquery-validation");
require("jquery-validation-unobtrusive");
require("./jQuery.booleanRequired");
require("bootstrap");
if ($('main > .container').height() > $(window).height()) {
    $('body').append('<style>@@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { body { height:auto; } }</style>');
}
